import { useEffect, useState } from 'react';
import { bootstrapOpenFin } from './provider';
import { useServices } from '../hooks';

type Status = 'Init' | 'Bootstrapping' | 'BootStrapped';

export function useIndigoWithOpenFin() {
    const [status, setStatus] = useState<Status>('Init');

    const {
        actionsIntervalDispatcherFactory,
        embeddedApiService,
        loggingService,
        marketDataService,
        symbolsService,
    } = useServices();

    useEffect(() => {
        if (status === 'Init') {
            setStatus('Bootstrapping');
            bootstrapOpenFin({
                actionsIntervalDispatcherFactory,
                embeddedApiService,
                loggingService,
                marketDataService,
                symbolsService,
            }).then(() => setStatus('BootStrapped'));
        }
    }, [
        status,
        embeddedApiService,
        loggingService,
        marketDataService,
        actionsIntervalDispatcherFactory,
        symbolsService,
    ]);
}
